/**
 * Environment configuration for AskWingo frontend.
 *
 * All service URLs should come from VITE_ env vars.
 * Defaults are placeholder values for local development.
 *
 * File upload constraints (MIME types, max size) live in constants.ts
 * — the frontend mirror of the shared Python constants module.
 */

import { ALLOWED_MIME_TYPES, MAX_FILE_SIZE_BYTES } from './constants';

export const config = {
  // API Base URLs — use ?? (not ||) so empty-string overrides from .env.phone
  // are preserved as relative paths for Vite proxy, rather than falling back
  // to localhost defaults the phone can't reach.
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000',
  GATEWAY_URL: import.meta.env.VITE_GATEWAY_URL ?? 'http://localhost:8000',
  QUERY_ROUTER_URL: import.meta.env.VITE_QUERY_ROUTER_URL ?? 'http://localhost:8001',
  CONNECTOR_SYNC_URL: import.meta.env.VITE_CONNECTOR_SYNC_URL ?? 'http://localhost:8002',
  DRIVE_CRAWLER_URL: import.meta.env.VITE_DRIVE_CRAWLER_URL ?? 'http://localhost:8003',
  GMAIL_CONNECTOR_URL: import.meta.env.VITE_GMAIL_CONNECTOR_URL ?? 'http://localhost:8004',
  // Kinetic + Notification are proxied through the gateway — no separate URLs needed.
  // See gateway_service/src/gateway/routes/proxy.py for the proxy routes.
  ORCHESTRATOR_URL: import.meta.env.VITE_ORCHESTRATOR_URL ?? 'http://localhost:8000',

  // Environment
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || 'development',

  // Auth mode: 'dev' = auto-login with dev token, 'real' = login/signup required
  AUTH_MODE: (import.meta.env.VITE_AUTH_MODE || 'dev') as 'dev' | 'real',

  // Feature flags
  ENABLE_DATA_SOURCES: true,
  ENABLE_FILE_UPLOAD: true,
  ENABLE_QUERY: true,
  ENABLE_REVIEW_QUEUE: true,
  ENABLE_DOCUMENTS: false, // Coming soon
  ENABLE_REPORTS: false, // Coming soon

  // App settings — canonical source: constants.ts
  MAX_FILE_SIZE: MAX_FILE_SIZE_BYTES,
  SUPPORTED_FILE_TYPES: [...ALLOWED_MIME_TYPES],

  // Grafana Cloud — embedded monitoring dashboards (public dashboard UIDs)
  GRAFANA_BASE_URL: import.meta.env.VITE_GRAFANA_BASE_URL ?? 'https://estevanmccalley.grafana.net',
  GRAFANA_PIPELINE_UID: import.meta.env.VITE_GRAFANA_PIPELINE_UID ?? 'a96482f6d5e04e3ca8e891b47041cb50',
  GRAFANA_SERVICES_UID: import.meta.env.VITE_GRAFANA_SERVICES_UID ?? '91083be6a3ba4a43a7fdfac256545b27',
  GRAFANA_LLM_UID: import.meta.env.VITE_GRAFANA_LLM_UID ?? '8a99c2d1ff76493d85ee0d86b01ddf56',
  GRAFANA_QUEUE_DEPTH_UID: import.meta.env.VITE_GRAFANA_QUEUE_DEPTH_UID ?? '2b9518cdb0e24b3a9460b7e4e8ae79eb',
  GRAFANA_RESOURCE_SAT_UID: import.meta.env.VITE_GRAFANA_RESOURCE_SAT_UID ?? 'e4c943d9726c4b81a181d8093e69cc87',

  // Marker.io feedback widget — gated to allowlisted UAT users (see src/lib/marker.ts)
  MARKER_PROJECT_ID: import.meta.env.VITE_MARKER_PROJECT_ID ?? '',

  // UI settings
  DEFAULT_PAGE_SIZE: 20,
};
